import { gravatarUrl } from '@goaltree/ui/lib/gravatar'
import { useMemo, useState } from 'react'

import { dicebearUrl } from '@/lib/avatar'

/**
 * Avatar image with a fallback chain: real photo → Gravatar (when an email is
 * known) → DiceBear cartoon. Never falls back to initials. Gravatar is skipped
 * when no email is available (e.g. other users on the leaderboard).
 */
export function UserAvatar({
  image,
  email,
  name,
  size = 96,
  className,
}: {
  image?: string | null
  email?: string | null
  name?: string | null
  size?: number
  className?: string
}) {
  const chain = useMemo(
    () =>
      [
        image || null,
        email ? gravatarUrl(email, size) : null,
        dicebearUrl(name || email || ''),
      ].filter(Boolean) as string[],
    [image, email, name, size],
  )
  const [level, setLevel] = useState(0)
  const src = chain[Math.min(level, chain.length - 1)]
  return (
    <img
      src={src}
      alt={name ?? ''}
      referrerPolicy="no-referrer"
      loading="lazy"
      decoding="async"
      width={size}
      height={size}
      onError={() => setLevel((l) => (l < chain.length - 1 ? l + 1 : l))}
      className={className}
    />
  )
}
